<template>
  <ErrorView/>
</template>

<script>
  import ErrorView from '../components/ErrorView'

  export default {
    components: {
      ErrorView
    }
  }
</script>

<style>

</style>
